import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CustomValidators } from 'ng2-validation';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';;
import { UserService } from 'src/app/services/user.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { CareerService } from 'src/app/services/career.service';
import { OpponentsService } from 'src/app/services/opponents.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import { TournamentDrawService } from 'src/app/services/tournament-draw.service';
import * as moment from 'moment';
@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class RankingComponent implements OnInit {
  public item;
  public profileDetails;
  public loggedInUser;
  public userId;
  public isLoggedIn: boolean = false;
  public data: any;
  public careerDetails;
  public highestSkillJumpDetails;
  public options = {
    title: {
      display: true,
      text: 'My Title',
      fontSize: 16
    },
    legend: {
      position: 'bottom'
    }
  }
  public opponentList: any = [];
  public tournamentList: any = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  rankData: any;
  rankingData: any;
  currentYear;
  basicOptions: any;
  public paginationOption = environment.pagination;
  public rankingList: any = [];
  private lazyLoadEvent: LazyLoadEvent;
  public downloadFlg: boolean = false;
  public loading: boolean = false;
  public totalRecords: Number = 0;
  public startDate: Date;
  public endDate: Date;
  public errorMessage;
  public searchby;
  public highestRankNumber;
  public highestRankNumberCreatedAt;
  public yearOptions: any[] = [];
  public selectedYear;
  public yearRangeForChart = environment.yearRangeForChart;
  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private userService: UserService,
    private careerService: CareerService,
    private opponentsService: OpponentsService,
    private tournamentsService: TournamentsService,
    private tournamentDrawService: TournamentDrawService,
  ) {
  }
  ngOnInit(): void {
    for (let i = 0; i < this.yearRangeForChart; i++) {
      let year = Number(2000) + i;
      this.yearOptions.push({ year: year.toString() });
    }
    let date = new Date();
    this.selectedYear = { year: date.getFullYear().toString() };
    this.currentYear = moment(new Date()).format('YYYY');
    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          ticks: {
            color: '#495057',
            beginAtZero: true,
            stepSize: 10
          },
          grid: {
            color: '#ebedef'
          }
        }
      }
    };
    // this.rankData = {
    //   labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    //   datasets: [
    //     {
    //       label: 'Rank',
    //       data: [0, 10, 5, 2, 20, 1, 12, 25, 20, 10, 8],
    //       fill: false,
    //       borderColor: '#42A5F5',
    //       tension: .4
    //     },
    //   ]
    // };
    // this.rankingData = {
    //   labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    //   datasets: [
    //     {
    //       label: 'Ranking',
    //       data: [10, 1, 15, 23, 2, 12, 15, 5, 1, 10, 8],
    //       fill: false,
    //       borderColor: '#7CFC00',
    //       tension: .4
    //     },
    //   ]
    // };

    this.data = {
      // labels: ['Skill', 'Skill', 'Skill'],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ]
        }]
    };
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(['/']);
    }
    //this.getPlayerRanking(this.userId);
    this.getPlayerRankingForcategoryWise(this.userId)
  }
  getPlayerRanking(userId) {
    var query = "?filterDisable=false&filterByUserId=" + userId + "&filterByYear=" + this.selectedYear.year;
    this.userService.getUserRankingForCategoryWise(query).subscribe(
      (data) => {
        let rankingData = data.data.items;
        let labelsArray = [];
        let dataSet = [];
        if (rankingData.length > 0) {
          rankingData.forEach(element => {
            labelsArray.push(moment(element.date).format('MMM YYYY'));
            dataSet.push(Number(element.playerRankin))
          });
        }
        this.rankingData = {
          labels: labelsArray,
          datasets: [
            {
              label: 'Rank',
              data: dataSet,
              fill: false,
              borderColor: '#42A5F5',
              tension: .4
            },
          ]
        };
      })
  }
  loadRanking(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    var query = "?filterByDisable=false&filterByPlayer=" + this.userId;
    var pagenumber = 1;
    var params = "";
    var rows = 2;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 2;
    }
    if (params != undefined && params != "") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    console.log(query);
    this.tournamentsService.tournamentLeaderPlayerscore(this.userId, query).subscribe(data => {
      this.rankingList = data['items'];
      this.highestRankNumber = data['highestRankNumber']['highRank'];
      this.highestRankNumberCreatedAt = data['highestRankNumber']['created_at'];
      this.totalRecords = data['totalCount'];
    },
      err => {
        this.errorMessage = err.error.message;
      });
  }


  getPlayerRankingForcategoryWise(userId) {
    var query = "?filterDisable=false&filterByUserId=" + userId + "&filterByYear=" + this.selectedYear.year;
    this.userService.getUserRankingForCategoryWise(query).subscribe(
      (data) => {
       
        let rankData = data.data.items;
        let labelsArray = [];
        let labelsArrayCategory =[];
        //this.skillsData = {};
        let dataSet = [];

        if (rankData.length > 0) {
          rankData.forEach(element => {
            labelsArray.push(moment(element.date).format('MMM YYYY'));
            labelsArrayCategory.push(element.matchname[0]+element.agegroupname[0]);
            let obj ={
                        label: element.matchname[0]+ " "+element.agegroupname[0],
                        data: element.pointsEarn,
                        fill: false,
                        borderColor: '#eb7ca6',
                        tension: .4                      
            }
            dataSet.push(obj);
          })
          this.rankData = {

            labels: labelsArray,
            datasets:dataSet
          
        };
        }

      }
      
      )
  }

  onClickYear(event) {
    this.selectedYear = event.value;
    //this.getPlayerRanking(this.userId);
    this.getPlayerRankingForcategoryWise(this.userId)
  }
}
